import { usePostsByTaxonomy } from "@gik/api/posts/postsByTaxonomy";
import { ArticlesGridSkeleton } from "@gik/blog/components/ArticlesGrid/ArticlesGridSkeleton";
import { FetchProvider } from "@gik/core/components/DynamicComponent/FetchProvider";
import type WordpressPost from "@gik/core/models/wordpress/WordpressPost";
import routes from "@gik/core/routes";
import * as NetworkStoreApi from "@gik/core/stores/NetworkStore.ts";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { Button } from "@gik/ui-legacy/Button";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";
import { GivePageArticlesGrid } from "./GivePageArticlesGrid";

export type TaxonomyPageRelatedArticlesProps = {
	taxonomySlug: string;
	taxonomyItemSlug: string;
	fallbackData?: WordpressPost[];
	title: string;
	page: number;
};

function TaxonomyPageRelatedArticlesComp({
	taxonomyItemSlug,
	taxonomySlug,
	title,
	fallbackData,
	page,
}: TaxonomyPageRelatedArticlesProps): React.ReactElement {
	const fullTitle = `More Articles about ${title}`;

	// Generate unique request key for NetworkStore tracking
	const requestKey = `taxonomy-posts-${taxonomySlug}-${taxonomyItemSlug}-${page}`;

	return (
		<FetchProvider<WordpressPost[]>
			fetch={function useFetch() {
				return usePostsByTaxonomy(
					{ taxonomySlug, taxonomyItemSlug, page, perPage: 4 },
					{ fallbackData, requestKey },
				);
			}}
			loadingComponent={<ArticlesGridSkeleton title={fullTitle} />}
			requestKey={requestKey}
			useNetworkStore={true}
		>
			{({ data }) => (
				<>
					<GivePageArticlesGrid title={fullTitle} data={data} />
					<PageSection centered noPadBottom>
						<Button
							type={"a"}
							href={`${routes.blog}/general-results/${taxonomySlug}/${taxonomyItemSlug}`}
							variant="primary-plain"
						>
							Find more helpful articles
						</Button>
					</PageSection>
				</>
			)}
		</FetchProvider>
	);
}

export const TaxonomyPageRelatedArticles = withComponentErrorBoundary(
	TaxonomyPageRelatedArticlesComp,
);
